/**
 * @file
 * Generate tools script file.
 *
 * This file includes all JS partials from the tools subdirectory to generate
 * all JS methods for global use.
 */

//=require ./tools/*.js
